import { useTranslation } from 'react-i18next'

import { formatChatDay } from '../format'

interface ChatDateChipProps {
  value: string
  now?: Date
}

/** `Oggi` / `Ieri` / locale numeric date divider (UI_PARITY §3.11). */
export function ChatDateChip({ value, now = new Date() }: ChatDateChipProps) {
  const { t } = useTranslation()
  const label = formatChatDay(value, t, now)
  if (!label) return null

  const date = new Date(value)
  return (
    <li className="chat-date-chip">
      <time dateTime={Number.isNaN(date.getTime()) ? undefined : value}>
        {label}
      </time>
    </li>
  )
}

export function ChatSystemChip({ text }: { text: string }) {
  return (
    <div className="chat-system-chip">
      <span>{text}</span>
    </div>
  )
}
